exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sorted[data-v-402b2d3c]{background-color:rgba(0,0,0,.03)}", ""]);

// exports
